// @ts-nocheck
import axios from "axios";
import QS from "qs";
import router from "../router";
import Appconstance from "../config/Appconstance.js";
import store from "../vuex/index.js";
import ElementUI from "element-ui";
import formApi from "../api/formApi";
import urlConfig from "../config/urlConfig.js";
import adminApi from "../api/adminApi";
/**
 *  Ajax请求处理
 */

//设置超时时间
axios.defaults.timeout = 50000;
// post请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

/**
 * 对外接口
 * method 方法类型
 * url 访问地址
 * params 参数
 * loading 是否loading弹窗
 * mark 是否弹出提示框
 */
export function request(method, url, params, loading, mark) {
  if (loading) {
    startLoading();
  }
  url = process.env.API_ROOT + url;
  if (method == "Get") {
    return get(url, loading, mark);
  } else if (method == "Post") {
    return post(url, params, loading, mark);
  } else if (method == "Form") {
    return form(url, params, loading, mark);
  } else if (method == "ExportExcel") {
    return exportExcel(url, params, loading, mark);
  }
}

function exportExcel(url, params, loading, mark) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          token: store.state.token
        },
        responseType: "arraybuffer"
        // arraybuffer
      })
      .then(res => {
        if (callBack(res.data, loading, mark)) {
          resolve(res.data);
        }
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 封装get方法
function get(url, loading, mark) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          token: store.state.token
        }
      })
      .then(res => {
        if (callBack(res.data, loading, mark)) {
          resolve(res.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 封装post方法
// function post(url, params, loading, mark) {
//   return new Promise((resolve, reject) => {
//     axios
//       .post(url, params, {
//         headers: {
//           token: store.state.token,
//           urlToken: res.data.mapInfo.urlToken
//         }
//       })
//       .then(res => {
//         if (callBack(res.data, loading, mark)) {
//           resolve(res.data);
//         }
//       })
//       .catch(err => {
//         reject(err);
//       });
//   });
// }
function post(url, params, loading, mark, errorHint) {
  return new Promise((resolve, reject) => {
    // 原来传进来的路径
    var oldUrl = url.split(process.env.API_ROOT)[1];

    // 是否为表单提交
    if (formApi.urlList.indexOf(oldUrl) != -1) {
      let submitUrl = "";
      // 获取访问令牌的url
      if (oldUrl.indexOf(urlConfig.erp + "/") != -1) {
        submitUrl = "/" + oldUrl.split(urlConfig.erp + "/")[1];
      } else if (oldUrl.indexOf(urlConfig.authority + "/") != -1) {
        submitUrl = "/" + oldUrl.split(urlConfig.authority + "/")[1];
      }
      let obj = {
        url: submitUrl
      };
      // 获得表单提交令牌
      axios
        .post(process.env.API_ROOT + adminApi.getSubmitToken, obj, {
          headers: {
            token: store.state.token
          }
        })
        .then(res => {
          axios
            .post(url, params, {
              headers: {
                token: store.state.token,
                urlToken: res.data.mapInfo.urlToken
              }
            })
            .then(response => {
              if (callBack(response.data, loading, mark, errorHint)) {
                resolve(response.data);
              }
            })
            .catch(err => {
              reject(err);
            });
        });
    } else {
      axios
        .post(url, params, {
          headers: {
            token: store.state.token
          }
        })
        .then(res => {
          if (callBack(res.data, loading, mark, errorHint)) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    }
  });
}
// 封装表单方法
function form(url, params, loading, mark) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params), {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          token: store.state.token
        }
      })
      .then(res => {
        callBack(res.data, mark);
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

//请求拦截(请求发出前处理请求)
axios.interceptors.request.use();

// 响应拦截器（处理响应数据）
axios.interceptors.response.use();

// 回调执行的方法
function callBack(res, loading, mark) {
  // 访问状态
  let status = true;

  // 如果是token失效
  if (
    res.status == Appconstance.messagesInfo.CODE_LOGIN_OVERTIME ||
    res.status == Appconstance.messagesInfo.CODE_LOGIN_OVERDUE
  ) {
    // 清空以前的token
    store.dispatch("setToken", "");
    router.replace({
      path: "/login",
      query: {
        redirect: router.currentRoute.fullPath
      }
    });
    status = false;
  }

  if (loading) {
    endLoading();
  }
  if (res.status == Appconstance.messagesInfo.CODE_SUCCESS) {
    if (res.info != "" && res.info != null) {
      if (mark) {
        ElementUI.Message({
          message: res.info,
          type: "success"
        });
      }
    }
  } else if (res.status == Appconstance.messagesInfo.CODE_ERROR) {
    // 系统异常显示请求id
    ElementUI.Message({
      message: res.info + "[" + res.MDC + "]",
      type: "error"
    });
    status = false;
  } else if (res.status == Appconstance.messagesInfo.CUSTOM_ERROR) {
    ElementUI.Message({
      message: res.info,
      type: "warning"
    });
    status = false;
  } else if (res.status == 7000014) {
    status=true
  }

  return status;
}
let loading;
// 开启加载弹窗
function startLoading() {
  loading = ElementUI.Loading.service({
    lock: true,
    text: "加载中……",
    background: "rgba(0, 0, 0, 0.7)"
  });
}

function endLoading() {
  loading.close();
}



// WEBPACK FOOTER //
// ./src/utils/ajaxProxy.js